export default __webpack_public_path__ + "c075a2c18dea5fcc46f1229165a8b058.svg";